import React, { useEffect, useState } from "react";
import {
  Paper,
  Box,
  Grid,
  Stack,
  Typography,
  Button,
  CardContent,
  TableCell,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
} from "@mui/material";
import NoSelectContact from "../../Assets/images/svg/noskillset.svg";
import { Chart } from "react-google-charts";
import axios from "axios";
import { BaseUrl, newBaseUrlLang } from "../../Container/BaseUrl/BaseUrl";
import { toast } from "react-toastify";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import { toaststyle } from "../../Utils/toaststyle";
import { ArrowsCounterClockwise } from "@phosphor-icons/react";
import Avatar from "@mui/material/Avatar";
import Nodata from "../../Assets/images/svg/nochart.svg";
import moment from "moment";

const StyledPaper = styled(Paper)(({ theme }) => ({
  height: "100%",
  padding: "0px 0px 15px 0px",
  background: "none",
  boxShadow: "none",
  borderRadius: "none",
  overflow: "hidden",
  display: "flex",
  flexDirection: "row",
}));

const Statistic = () => {
  const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
  const [skillName, setskillName] = useState([]);
  const [openChart, SetOpenChart] = useState(false);
  const [selectedSkillset, setselectedSkillSet] = useState();
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [isData2Available, setIsData2Available] = useState(false);
  const [spinner, setspinner] = useState("");
  const [tabledata, setTabledata] = useState([]);


  

  const theme = useTheme();
  const [data, setData] = useState([
    ["Language", "Speakers (in millions)"],
    ["Ready"],
    ["Not Ready"],
  ]);

  const [options, setOptions] = useState({
    legend: "none",
    pieSliceText: "label",
    // title: "Swiss Language Use (Straight Line)",
    pieStartAngle: 0,
    pieEndAngle: 0,
    titleTextStyle: {
      fontSize: 12, // Adjust font size for the title
    },
    // Other chart options
    vAxis: {
      textStyle: {
        fontSize: 10, // Adjust font size for vAxis labels
      },
    },
    hAxis: {
      textStyle: {
        fontSize: 8, // Adjust font size for hAxis labels
      },
    },
    legend: {
      position: "top",
      textStyle: {
        fontSize: 11, // Adjust font size for legend text
      },
    },
  });

  const [legendData, setLegendData] = useState([
    { color: "#4285F4", text: "Available", fontSize: "11px" },
    { color: "#dc3912", text: "Not Ready", fontSize: "11px" },
  ]);

  const [data2, setData2] = useState([
    ["Language", "Speakers (in millions)"],
    ["90%", 90],
    ["10%", 10],
  ]);

  const [options2, setOptions2] = useState({
    legend: "none",
    pieSliceText: "label",
    // title: "Swiss Language Use (Straight Line)",
    pieStartAngle: 0,
    pieEndAngle: 0,
    titleTextStyle: {
      fontSize: 12, // Adjust font size for the title
    },
    // Other chart options
    vAxis: {
      textStyle: {
        fontSize: 10, // Adjust font size for vAxis labels
      },
    },
    hAxis: {
      textStyle: {
        fontSize: 8, // Adjust font size for hAxis labels
      },
    },
    legend: {
      position: "top",
      textStyle: {
        fontSize: 11, // Adjust font size for legend text
      },
    },
  });
  const [sla, setSla] = useState(0);
  const [legendData2, setLegendData2] = useState([
    { color: "#4285F4", text: "Offered", fontSize: "10px" },
    { color: "#dc3912", text: "Waiting", fontSize: "10px" },
  ]);

  const webStatisticStatus = async (item) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/dashboard/webStatistic`,
        {
          skillset: item.skillName,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      );

      if (response.data.status == true) {
        console.log(response.data.agentIncall);
        setTabledata(response.data.agentIncall);
        setSla(response.data.slacount ? response.data.slacount : 0);
        setspinner("");
        setData([
          ["Language", "Speakers (in millions)"],
          ["Ready", response.data.dataready],
          ["Not Ready", response.data.datanotready],
        ]);
        setData2([
          ["Language", "Speakers (in millions)"],
          ["offered", response.data.chatcompleted],
          ["waiting", response.data.chatincomplete],
        ]);
        setIsDataAvailable(
          response.data.dataready !== 0 || response.data.datanotready !== 0
        );
        setIsData2Available(
          response.data.chatcompleted !== 0 ||
            response.data.chatincomplete !== 0
        );
      } else {
        setspinner("");
        toast.warn(response.data.message, toaststyle);
      }
    } catch (error) {
      console.log(error);
      setspinner("");
    }
  };

  const SupervisorskillsetListDetails = async () => {
    let data = {
      enabled: true,
    };
    await axios
      .post(newBaseUrlLang + "usermodule/clientMaster/skills/list", data, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.status == "OK") {
          setskillName(res.data.dataList);
        } else {
          setskillName([]);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const AgentSkillsetListDetails = async () => {
    await axios
      .post(
        newBaseUrlLang + "v1/skillset/skillsetlist",
        {
          userId: loggedInAgent.user_id,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setskillName(res.data.data);
        } else {
          setskillName([]);
        }
      })
      .catch((error) => {
        setskillName([]);
        console.log("error", error);
      });
  };

  useEffect(() => {
    if (loggedInAgent.role == "Supervisor") {
      SupervisorskillsetListDetails();
    } else {
      AgentSkillsetListDetails();
    }
  }, []);
 useEffect(() => {
    const intervalId = setInterval(() => {
      if (loggedInAgent.role == "Supervisor") {
        SupervisorskillsetListDetails();
        setspinner("spin 1s infinite");
        webStatisticStatus(selectedSkillset);
      } else {
        AgentSkillsetListDetails();
        setspinner("spin 1s infinite");
        webStatisticStatus(selectedSkillset);
      }
    }, 60000);
    return () => clearInterval(intervalId);
  }, [loggedInAgent.role, selectedSkillset, SupervisorskillsetListDetails, AgentSkillsetListDetails, webStatisticStatus]);
  return (
    <>
      <Stack
        sx={{
          height: "100%",
          width: "100%",
          borderRadius: "7px",
          background: " #EEF7FF",
          overflow: "hidden",
          overflowY: "none",
        }}
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        {/* skisetlist start  */}
        <Stack
          className="me-1"
          sx={{
            height: "calc(100vh - 68px)",
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
            width: "16rem",
            borderRadius: "7px 0 0 0",
            background: "white",
          }}
        >
          <Box
            sx={{
              boxShadow:
                "0px 1px 0px rgba(17,17,26,0.05), 0px 0px 8px rgba(17,17,26,0.1)",
            }}
            className="p-2"
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: "15px",
                fontWeight: "600",
                color: "#0b3363",
              }}
              gutterBottom
              className="px-2 mb-0"
            >
              Skillsets
            </Typography>
          </Box>

          <Box
            className="p-2 skisetlist"
            sx={{
              overflow: "hidden",
              overflowY: "auto",
            }}
          >
            {skillName.length > 0 &&
              skillName.map((item) => (
                <div
                  key={item.skillId}
                  onClick={() => {
                    console.log("itemitem", item);
                    SetOpenChart(true);
                    webStatisticStatus(item);
                    setselectedSkillSet(item);
                  }}
                  className={
                    selectedSkillset
                      ? selectedSkillset.skillId == item.skillId
                        ? "chat-contact d-flex chat-active mb-1"
                        : "chat-contact d-flex mb-1"
                      : "chat-contact d-flex mb-1"
                  }
                  style={{ cursor: "pointer" }}
                >
                  <Box
                    sx={{
                      padding: "2px 5px",
                      width: "80%",
                    }}
                  >
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      spacing={1}
                      justifyContent={"space-between"}
                    >
                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        spacing={1}
                      >
                        <Avatar
                          className="box-inset2"
                          sx={{
                            background: "#86A7FC",
                            height: "35px",
                            width: "35px",
                            fontSize: "12px",
                            fontWeight: 600,
                          }}
                        >
                          {item.skillName.slice(0, 2).toUpperCase()}
                        </Avatar>

                        <Stack alignItems={"start"}>
                          <Stack
                            spacing={0.5}
                            alignItems={"center"}
                            direction={"row"}
                          >
                            <Typography
                              variant="subtitle"
                              noWrap
                              sx={{
                                color: selectedSkillset
                                  ? selectedSkillset == item.skillId
                                    ? "white"
                                    : "black"
                                  : "",
                                maxWidth: "152px",
                                fontSize: "13px",
                                textTransform: "capitalize",
                              }}
                            >
                              {item.skillName}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Box>
                </div>
              ))}
          </Box>
        </Stack>
        {/* skisetlist end  */}
        <Stack className="w-100 h-100">
          {/* SkillSet not found start  */}
          {!openChart && (
            <Stack
              style={{
                height: "100%",
                width: "100% ",
                userSelect: "none",
              }}
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={0.5}
            >
              <Stack
                alignItems={"center"}
                justifyContent={"center"}
                spacing={2}
                sx={{ height: "100%", width: "100%" }}
              >
                <img
                  src={NoSelectContact}
                  alt="pic"
                  style={{ width: "25rem", userSelect: "none" }}
                />
                <h4
                  style={{
                    color: "#3BA0E1",
                    fontWeight: "600",
                    userSelect: "none",
                    fontSize: "13px",
                  }}
                >
                  SkillSet not found. Please select a SkillSet.
                </h4>
              </Stack>
            </Stack>
          )}
          {/* SkillSet not found end  */}

          {/* user chart content start  */}
          {openChart && (
            <Box
              className="w-100 h-100 bg-white position-relative"
              sx={{ overflowY: "auto" }}
            >
              {/* refeshbtn start */}
              <Box className="refresh-btn">
                <Button
                  disableElevation
                  size="small"
                  variant="text"
                  sx={{
                    textTransform: "capitalize",
                    fontSize: "12px",
                    borderRadius: "0",
                    color: "white",
                  }}
                  endIcon={
                    <ArrowsCounterClockwise
                      size={12}
                      style={{ animation: spinner }}
                    />
                  }
                  onClick={() => {
                    if (loggedInAgent.role == "Supervisor") {
                      SupervisorskillsetListDetails();
                      setspinner("spin 1s infinite");
                      webStatisticStatus(selectedSkillset);
                    } else {
                      AgentSkillsetListDetails();
                      setspinner("spin 1s infinite");
                      webStatisticStatus(selectedSkillset);
                    }
                  }}
                >
                  Refresh
                </Button>
              </Box>
              {/* refeshbtn end */}
              <Grid item xs={12}>
                <card>
                  <CardContent>
                    <Box sx={{ mt: 3 }}>
                      <TableContainer component={Paper}sx={{ mt: 2 }}>
                        <Table aria-label="simple table">
                          <TableHead
                            sx={{ background: "#50a4fd", color: "white" }}
                          >
                            <TableRow>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "white" }}
                              >
                                Agent Name
                              </TableCell>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "white" }}
                              >
                                Phone Number
                              </TableCell>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "white" }}
                              >
                                Arrival Time
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {tabledata && tabledata.length > 0 ? (
                              tabledata.map((item, index) => (
                                <TableRow key={index}>
                                  <TableCell>{item.agentname}</TableCell>
                                  <TableCell>{item.Phonenumber}</TableCell>
                                  <TableCell>
                                    {moment(item.arrival_at).format(
                                      "DD/MM/YYYY HH:mm A"
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={3} align="center">
                                  No Data Found
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </CardContent>
                </card>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <card>
                    <CardContent>
                      <Typography
                        sx={{ fontSize: 15 }}
                        gutterBottom
                        className="fw-bold textp text-center"
                      >
                        Agent
                      </Typography>
                      <Box>
                        {/* legendData start  */}
                        <div
                          className="d-none"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "20px",
                          }}
                        >
                          {legendData.map((item, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginRight: "20px",
                              }}
                            >
                              <div
                                style={{
                                  width: "40px",
                                  height: "15px",
                                  backgroundColor: item.color,
                                  marginRight: "5px",
                                }}
                              ></div>
                              <span>{item.text}</span>
                            </div>
                          ))}
                        </div>
                        {/* legendData end  */}
                        <Stack sx={{ height: "320px", width: "100%" }}>
                          {isDataAvailable ? (
                            <Chart
                              chartType="PieChart"
                              data={data}
                              options={options}
                              width={"100%"}
                              height={"350px"}
                              fontSize={"13px"}
                            />
                          ) : (
                            // Data unavailable start
                            <Stack
                              sx={{
                                position: "absolute",
                                width: "47%",
                                height: "55%",
                              }}
                              justifyContent="center"
                              alignContent="center"
                            >
                              <Stack
                                className="text-muted"
                                direction="column"
                                justifyContent="center"
                                alignContent="center"
                              >
                                <span className="mx-auto">
                                  <img
                                    src={Nodata}
                                    alt="pic"
                                    style={{
                                      width: "16rem",
                                      userSelect: "none",
                                    }}
                                  />
                                </span>
                                <span className="mx-auto">
                                  <h6
                                    className="text-muted mt-3 ms-4 ps-5"
                                    style={{ fontSize: "13px" }}
                                  >
                                    Data unavailable
                                  </h6>
                                </span>
                              </Stack>
                            </Stack>
                            // Data unavailable end
                          )}
                        </Stack>
                      </Box>
                    </CardContent>
                  </card>
                </Grid>
                <Grid item xs={6}>
                  <card>
                    <CardContent>
                      <Typography
                        sx={{ fontSize: 15 }}
                        gutterBottom
                        className="fw-bold textp text-center"
                      >
                        Digital Contacts
                      </Typography>
                      <Box>
                        {/* legendData start  */}
                        <div
                          className="d-none"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "20px",
                          }}
                        >
                          {legendData2.map((item, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginRight: "20px",
                              }}
                            >
                              <div
                                style={{
                                  width: "40px",
                                  height: "15px",
                                  backgroundColor: item.color,
                                  marginRight: "5px",
                                }}
                              ></div>
                              <span>{item.text}</span>
                            </div>
                          ))}
                          <Stack
                            sx={{
                              fontSize: "13px",
                              marginLeft: "10px",
                            }}
                          >
                            <span>Service level: {sla}%</span>
                          </Stack>
                        </div>
                        {/* legendData end  */}
                        <Stack sx={{ height: "320px", width: "100%" }}>
                          {isData2Available ? (
                            <Chart
                              chartType="PieChart"
                              data={data2}
                              options={options2}
                              width={"100%"}
                              height={"350px"}
                            />
                          ) : (
                            // Data unavailable start
                            <Stack
                              sx={{
                                position: "absolute",
                                width: "47%",
                                height: "55%",
                              }}
                              justifyContent="center"
                              alignContent="center"
                            >
                              <Stack
                                className="text-muted"
                                direction="column"
                                justifyContent="center"
                                alignContent="center"
                              >
                                <span className="mx-auto">
                                  <img
                                    src={Nodata}
                                    alt="pic"
                                    style={{
                                      width: "16rem",
                                      userSelect: "none",
                                    }}
                                  />
                                </span>
                                <span className="mx-auto">
                                  <h6
                                    className="text-muted mt-3 ms-4 ps-5"
                                    style={{ fontSize: "13px" }}
                                  >
                                    Data unavailable
                                  </h6>
                                </span>
                              </Stack>
                            </Stack>
                            // Data unavailable end
                          )}
                        </Stack>
                      </Box>
                    </CardContent>
                  </card>
                </Grid>
              </Grid>
              
            </Box>
          )}
          {/* user chart content end  */}
        </Stack>
      </Stack>
    </>
  );
};

export default Statistic;
